import React, { Component } from 'react';
import ConfigureStore from '../ConfigureStore'

class Callback extends Component {

  render() {
     return (
        <div class="loading-overlay">
            <div class="spinner">
                <div class="inner">
                    <div class="gap"></div>
                    <div class="left">
                        <div class="half-circle"></div>
                    </div>
                    <div class="right">
                        <div class="half-circle"></div>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}


const updateUserAction = {
    type: 'updateUser',
    payload: {
        user: 'John'
    }
}

//ConfigureStore.dispatch(updateUserAction)

export default Callback